import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/jobTemplates'
import Component from 'components/JobTemplates'

export default createListViewContainer({ actions, selectors: selectors.jobTemplates })(Component)
